module.exports = "<div class=\"kan-mail-list\">\n    <kan-mail-list-item *ngFor=\"let mail of mails\"\n                        [mail]=\"mail\"\n                        (refresh)=\"emitRefresh()\">\n    </kan-mail-list-item>\n</div>\n\n"


//////////////////
// WEBPACK FOOTER
// ./src/modules/mails/components/list/component.html
// module id = ./src/modules/mails/components/list/component.html
// module chunks = main